import { gql } from '@apollo/client';
import client from 'apollo/apolloClient';

/**
 * Insert movements method
 * @param  {Array} payload
 * @return {Promise}
 */
const insert = (payload) => client.mutate({
  mutation: gql`
    mutation insertMaterialMovements($input: [InsertMaterialMovementInput!]!) {
      insertMaterialMovements(input: $input)
    }
  `,
  variables: { input: payload },
});

export default {
  insert,
};
